import React, { useState, useEffect } from 'react'
import faq from "../../Assets/faq.png"
import './faq.styles.scss'
import { ReactComponent as Minus } from "../../Assets/minus.svg"
import { ReactComponent as Plus } from "../../Assets/plus.svg"
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import emailjs from "@emailjs/browser"
import config from '../../config'
import { useNavigate } from 'react-router'
import ReCAPTCHA from 'react-google-recaptcha'

const Faq = () => {
    const [open, setOpen] = useState(0);
    const navigate = useNavigate();
    const [emailError, setEmailError] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [isRecaptchaOk, setIsRecaptchaOk] = useState(false);
    const [form, setForm] = useState({
        name: null,
        email: null,
        question: null,
        policy: false,
        marketing: false,
    });
    const { t } = useTranslation();
    const sx = {
        '&.Mui-checked': {
            color: '#7ab529',
        }
    }

    useEffect(() => {
        emailjs.init(config.apiKey)
    }, []);

    const handleOpen = (i) => {
        if (i === open) {
            setOpen();
        } else {
            setOpen(i);
        }
    }

    const onSubmit = (data) => {
        data.preventDefault();
        let body = {
            from_name: form.name,
            from_email: form.email,
            from_project: form.question,
        }
        emailjs.send(config.emailService, config.emailTemplate, body)
            .then(response => {
                navigate("/thanks")
            })
            .catch(error => console.log(error))
    }

    const onChange = (e) => {
        if (e.target.name === "email") {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(e.target.value)) {
                setEmailError(true);
            } else {
                setEmailError(false);
            }
        }
        setForm({
            ...form, [e.target.name]:
                e.target.name === "name" || e.target.name === "email" || e.target.name === "question" ? e.target.value : e.target.checked
        })
    }

    useEffect(() => {
        if (
            /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.email)
            && (form.name !== "" && form.name !== null)
            && (form.question !== "" && form.question !== null)
            && form.policy
        ) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [form])

    return (
        <div className='faq'>
            <div className='banner'>
                <div className='titleContainer'>
                    <label className='subtitle' aria-label={t("faq")}>{t("faq")}</label>
                    <label className='title' aria-label={t("faq.title")}>{t("faq.title")}</label>
                </div>
                <img src={faq} alt="FAQ" aria-label="FAQ banner" />
            </div>
            <div className='questions' role="region" aria-label="Domande frequenti">
                {[...Array(10)].map((_, index) => (
                    <div key={index} className='questions-box'>
                        <div
                            className={open === index ? "questions-box-title active" : "questions-box-title"}
                            onClick={() => handleOpen(index)}
                            role="button"
                            tabIndex={0}
                            aria-expanded={open === index}
                            aria-label={t(`faq.question${index + 1}`)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleOpen(index) }}
                        >
                            <label>{t(`faq.question${index + 1}`)}</label>
                            {open === index ? <Minus /> : <Plus />}
                        </div>
                        {open === index && (
                            <div className='questions-box-answer' aria-label={`Risposta ${index + 1}`}>
                                <label>{t(`faq${index + 1}`)}</label>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className='form' aria-label="Modulo contatto FAQ">
                <label className='title' aria-label={t("faq.other")}>{t("faq.other")}</label>
                <form onSubmit={onSubmit} noValidate>
                    <label htmlFor='name'>{t("nameSurname")}</label>
                    <input
                        className='custom-input'
                        id='name'
                        name='name'
                        type="text"
                        placeholder='Mario Rossi'
                        aria-label={t("nameSurname")}
                        onChange={onChange}
                        value={form.name}
                    />
                    <label htmlFor='email'>{t("email")}</label>
                    <input
                        className='custom-input'
                        id='email'
                        name='email'
                        type="email"
                        placeholder='Email@email.com'
                        aria-label={t("email")}
                        onChange={onChange}
                        value={form.email}
                    />
                    {emailError &&
                        <>
                            <small style={{ color: '#E7475E' }} aria-live="assertive">{t("error.email")}</small>
                            <br />
                        </>
                    }
                    <label htmlFor='question'>{t("writeYourQuestions")}</label>
                    <textarea
                        id='question'
                        name='question'
                        placeholder={t("insertYourQuestions")}
                        rows={10}
                        className='custom-input'
                        aria-label={t("writeYourQuestions")}
                        onChange={onChange}
                        value={form.question}
                    />
                    <FormGroup>
                        <FormControlLabel
                            required
                            control={
                                <Checkbox
                                    id='policy'
                                    name='policy'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.policy}
                                    inputProps={{ 'aria-label': t("policy") }}
                                />
                            }
                            label={t("policy")}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id='marketing'
                                    name='marketing'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.marketing}
                                    inputProps={{ 'aria-label': t("marketing") }}
                                />
                            }
                            label={t("marketing")}
                        />
                    </FormGroup>
                    <div aria-label="reCAPTCHA">
                        <ReCAPTCHA
                            sitekey={config.RECAPTCHA_API_KEY}
                            onChange={() => setIsRecaptchaOk(true)}
                            onExpired={() => setIsRecaptchaOk(false)}
                        />
                    </div>
                    <Button
                        type='submit'
                        variant="contained"
                        style={{ backgroundColor: '#416D03' }}
                        disabled={!isValid && !isRecaptchaOk}
                        aria-label={t("sendRequest")}
                    >
                        {t("sendRequest")}
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default Faq